import * as React from "react";
import { ui } from "../../../../contracts";
import { EventIcon } from "../EventIcon";
export const PulseBetIcon = (props) => {
    const isEmpty = !props.hasPulseBet;
    const tooltip = !isEmpty ? props.tooltip : "";
    return (React.createElement(EventIcon, { isEmpty: isEmpty, hideOnMobile: false, tooltip: tooltip }, props.hasPulseBet &&
        React.createElement(ui.Icon, { i: `i-24-16 i-o-ev-pulse` })));
};
//# sourceMappingURL=PulseBetIcon.js.map